import React, { useState } from "react";
import { toast } from "react-toastify";
import { FaRegPaperPlane } from "react-icons/fa";
import { Config } from "../../Config";
import "./OrderDetailModalItem.scss";

const OrderDetailModalItem = ({ doc, addToArray }) => {
  // const [orders, setOrders] = useState(null);
  const orderInputsHandler = async (file, doc, el, fileId) => {
    if (file.length > 0) {
      if (!el.target.files[0].type.includes("image")) {
        toast.error("لطفا عکس انتخاب کنید");
        return;
      }
      let tag = document.getElementById(`defaultImage_${doc.id}`);
      let formGroup = document.getElementById(`formGroup_${doc.id}`);
      let fr = new FileReader();
      fr.onload = function () {
        tag.src = fr.result;
        formGroup.classList.add("activeForm");
      };
      fr.readAsDataURL(el.target.files[0]);
      const fileInput = await Config.convertToBase64(file[0]);

      addToArray(fileInput, fileId);
      // setOrders([{ documentId: doc.id, file: fileInput }]);
    }
  };
  const clickNextInput = (id) => {
    let input = document.getElementById(id);
    input.click();
  };
  // const classNameHandler = (status) => {
  //   if (status === "WaitForConfirmation") {
  //     return `formGroup showImage wait`;
  //   } else if (status === "Rejected") {
  //     return `formGroup showImage rejected`;
  //   } else {
  //     return `formGroup`;
  //   }
  // };
  return (
    <div className="modalContentItem">
      {/* <div id={`formGroup_${doc.id}`} className={classNameHandler(doc.statusLevel)}> */}
      <div id={`formGroup_${doc.id}`} className="formGroup">
        <div className="orderAction">
          <div id={`selectArea_${doc.id}`} className="inputSelector" onClick={() => clickNextInput(doc.id)}>
            <span className="selectText">انتخاب کنید</span>
            {/* <img id={`defaultImage_${doc.id}`} alt="defImage" className="defImages" src={doc.image} /> */}
            <img id={`defaultImage_${doc.id}`} alt="defImage" className="defImages" />
          </div>
          <input
            className="orderInput"
            type="file"
            name={doc.id}
            data-buttontext="انتخاب کنید"
            id={doc.id}
            onChange={(e) => orderInputsHandler(e.target.files, doc, e, doc.id)}
          />
        </div>
        <div className="orderDetail" htmlFor={doc.id}>
          {doc.title}
          {/* <div className="statusWrapepr">
            <span className="statusText statusHeader">وضعیت :</span>
            {/* <span className="statusText status">آماده برای ارسال</span> */}
          {/* <span id={`status_${doc.id}`} className="statusText status">
              {doc.status}
            </span>
          </div> */}
        </div>
        {/* {doc.statusLevel === "Unkown" && (
          <button
            className="btnSubmitOrderList"
            onClick={async (e) => {
              e.target.classList.add("disableInput");
              await submitOrderHandler(data?.id, orders);
              e.target.classList.remove("disableInput");
            }}
          >
            <span className="sendText">ارسال</span>
            <FaRegPaperPlane className="sendPlane" />
          </button>
        )}
        {doc.statusLevel === "WaitForUploading" && (
          <button
            className="btnSubmitOrderList"
            onClick={async (e) => {
              e.target.classList.add("disableInput");
              await submitOrderHandler(data?.id, orders);
              e.target.classList.remove("disableInput");
            }}
          >
            <span className="sendText">ارسال</span>
            <FaRegPaperPlane className="sendPlane" />
          </button>
        )}
        {doc.statusLevel === "WaitForConfirmation" && (
          <button
            className="btnSubmitOrderList"
            onClick={async (e) => {
              e.target.classList.add("disableInput");
              await submitOrderHandler(data?.id, orders);
              e.target.classList.remove("disableInput");
            }}
          >
            <span className="sendText">به روز رسانی</span>
            <FaRegPaperPlane className="sendPlane" />
          </button>
        )} */}
        {/* <button
          className="btnSubmitOrderList"
          onClick={async (e) => {
            e.target.classList.add("disableInput");
            await submitOrderHandler(data?.id, orders);
            e.target.classList.remove("disableInput");
          }}
        >
          <span className="sendText">ارسال</span>
          <FaRegPaperPlane className="sendPlane" />
        </button> */}
      </div>
    </div>
  );
};

export default React.memo(OrderDetailModalItem);
